function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87284 5.97825C4.65153 7.57153 6.44563 8.88234 7.25 9.4125V10.8325L4.05444 12.75H11.9699L8.75 10.818V9.4125C9.55438 8.88216 11.3485 7.57134 12.1272 5.97806C14.7822 5.69888 15.5 2.48606 15.5 0.75C15.5 0.551088 15.421 0.360322 15.2803 0.21967C15.1397 0.0790176 14.9489 0 14.75 0L1.25 0C1.05109 0 0.860322 0.0790176 0.71967 0.21967C0.579018 0.360322 0.5 0.551088 0.5 0.75C0.5 2.48606 1.21784 5.69888 3.87284 5.97825ZM12.5 4.3305V1.5H13.9421C13.8283 2.39822 13.4919 3.84084 12.5 4.3305ZM3.5 1.5V4.3305C2.50803 3.84084 2.17156 2.39784 2.05794 1.5H3.5Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.51221 17.25C3.51221 17.4489 3.59122 17.6397 3.73188 17.7803C3.87253 17.921 4.06329 18 4.26221 18H11.7622C11.9611 18 12.1519 17.921 12.2925 17.7803C12.4332 17.6397 12.5122 17.4489 12.5122 17.25V13.5H3.51221V17.25Z"
});

var SvgTrophyIcon = function SvgTrophyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrophyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trophy-icon.6bde93f1.svg";
export { ForwardRef as ReactComponent };